import { render, staticRenderFns } from "./MailRegistrationMailSend.vue?vue&type=template&id=6c96dba0&"
import script from "./MailRegistrationMailSend.vue?vue&type=script&lang=js&"
export * from "./MailRegistrationMailSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports